import React from 'react';
import {
  StandardAreaInstallationsHeaderSection,
  StandardAreaInstallationsDetailSection
} from 'modules';
import { Box } from '@mui/material';

export type StandardAreaInstallationsActivityProps = {};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StandardAreaInstallationsActivity = (props: StandardAreaInstallationsActivityProps) => {

  return (
    <Box>
      <StandardAreaInstallationsHeaderSection.FC />
      <StandardAreaInstallationsDetailSection.FC />
    </Box>

  );
};
